import { signal } from '@preact/signals-react'

export const formData = signal({})
export const formErrors = signal({})